import React from 'react';
import PropTypes from 'prop-types';
import { I18nUtils } from '../../../i18n/I18nUtils';
import WorkImportRow from './WorkImportRow';
import { PsTable } from '../../shared/components/table/PsTable';

export default class WorkImportTable extends React.Component {

    renderHead() {
        return (
            <tr>
                <th>{I18nUtils.tr('TR_CODIGO')}</th>
                <th>{I18nUtils.tr('TR_NOMBRE')}</th>
                <th></th>
            </tr>
        );
    }

    render() {
        if ( this.props.error ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.error}</h3>
                </section>
            );
        }

        if ( this.props.data.Message ) {
            return (
                <section className={'error-section'}>
                    <h3 className={'text-center'}>{this.props.data.Message}</h3>
                </section>
            );
        }

        if ( !this.props.data || this.props.data.length === 0 ) {
            return null;
        }

        return (
            <PsTable headings={this.renderHead()}>
                {
                    this.props.data.map((work, i) =>
                        <WorkImportRow key={i} work={work} />,
                    )
                }
            </PsTable>
        );
    }

}

WorkImportTable.propTypes = {
    data: PropTypes.any.isRequired,
    error: PropTypes.string,
};
WorkImportTable.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/works/components/WorkImportTable.jsx